/*=============================================== StepperPage ===============================================*/

import { Stepper } from "tsx-library-julseb"
import type { StepProps } from "tsx-library-julseb/types"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, propAllLinks, iconBoxicon } from "data"

const StepperPage = () => {
    const steps: StepProps[] = [
        {
            text: "Step",
            to: "#",
        },
        {
            text: "Step",
            to: "#",
        },
        {
            text: "Step",
        },
        {
            text: "Step",
        },
        {
            text: "Step",
        },
    ]

    const items: ItemType[] = [
        {
            title: "Horizontal",
            content: (
                <Stepper steps={steps} active={2} iconActive="check-circle" />
            ),
            code: 'const steps = [\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n]\n\n<Stepper steps={steps} active={2} iconActive="check-circle" />',
            codeTs: 'const steps: StepProps[] = [\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n]\n\n<Stepper steps={steps} active={2} iconActive="check-circle" />',
        },
        {
            title: "Vertical",
            content: <Stepper steps={steps} active={2} direction="column" />,
            code: 'const steps = [\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n]\n\n<Stepper steps={steps} active={2} direction="column" />',
            codeTs: 'const steps: StepProps[] = [\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n        to: "#",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n    {\n        text: "Step",\n    },\n]\n\n<Stepper steps={steps} active={2} direction="column" />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "active",
            type: "number",
        },
        {
            subtitle: "direction",
            type: "string",
            possible: ["column", "row"],
            default: "row",
        },
        {
            subtitle: "iconActive",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("check"),
        },
        {
            subtitle: "iconSize",
            type: "number",
            default: 16,
        },
        "separator",
        {
            subtitle: "steps",
            type: "array of objects",
            required: true,
        },
        {
            title: (
                <>
                    <code>step</code> object
                </>
            ),
            subtitle: "text",
            type: "string",
            required: true,
        },
        ...propAllLinks,
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default StepperPage
